const event = {};

var dic = {};

event.set = function(eventName, onEvent) {
    dic[eventName] = onEvent;
};

event.clear = function(eventName) {
    delete dic[eventName];
};

event.clearAll = function(eventName) {
    dic = {};
};

event.call = function(eventName) {
    if (eventName in dic) {
        dic[eventName]();
    }
}

event.call = function(eventName) {
    if (eventName in dic) {
        switch (arguments.length) {
            case 1: dic[eventName](); break;
            case 2: dic[eventName](arguments[1]); break;
            case 3: dic[eventName](arguments[1], arguments[2]); break;
            case 4: dic[eventName](arguments[1], arguments[2], arguments[3]); break;
            case 5: dic[eventName](arguments[1], arguments[2], arguments[3], arguments[4]); break;
        }
    }
}

event.install = function(Vue) {
    Vue.prototype.$event = event;
}

export default event;


// WEBPACK FOOTER //
// ./src/event.js